import { Checkbox, CheckboxChangeEvent, CheckboxProps } from 'primereact/checkbox';
import React from 'react';
import { Control, Controller, ControllerRenderProps } from 'react-hook-form';

type RHFCheckboxProps = {
    control: Control<any>;
    name: string;
    disabled?: boolean;
    inputProps?: CheckboxProps;
    onChange?: (e: CheckboxChangeEvent, field: ControllerRenderProps) => void;
};

export const RHFCheckbox = ({ control, name, disabled, inputProps, onChange }: RHFCheckboxProps) => {
    return (
        <Controller
            name={name}
            control={control}
            disabled={disabled}
            render={({ field }) => (
                <Checkbox
                    inputId={field.name}
                    checked={field.value}
                    inputRef={field.ref}
                    disabled={field.disabled}
                    onChange={(e) => field.onChange(e.checked)}
                    {...inputProps}
                    {...(onChange && { onChange: (e: CheckboxChangeEvent) => onChange(e, field) })}
                />
            )}
        />
    );
};
